import { render, staticRenderFns } from "./FIBQuizScreen.vue?vue&type=template&id=fec5b46e&scoped=true&"
import script from "./FIBQuizScreen.vue?vue&type=script&lang=js&"
export * from "./FIBQuizScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec5b46e",
  null
  
)

export default component.exports